import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ConsumersService extends BaseService{

  constructor() {
    super();
  }
  getAllConsumers():Observable<any>{
  return this.httpService.get(APIUrl.allConsumers)
  }
  userUnlock(id){
    return this.httpService.postParams(`${APIUrl.userUnlock}/${id}`,'')
  }
  getConsumerbyId(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.allConsumers}/${id}`)
  }
  updateConsumer(formData): Observable<any> {
    return this.httpService.put(APIUrl.allConsumers, formData)
  }

  addNewUser(formData): Observable<any> {
    return this.httpService.post(APIUrl.userManage, formData)
  }
  updateUser(formData): Observable<any> {
    return this.httpService.put(APIUrl.userManage, formData)
  }
  updatePromocodeValidity(promoId,promocodeEnddttm): Observable<any> {
    let url: string= APIUrl.promoValidityUpdate;
    let params: any = new HttpParams().set('promocodeId', promoId).set('promocodeEndDateTime', promocodeEnddttm)
    return this.httpService.put(url, params)
  }
  LoyaltyPointHistory(userId:any,days:any):Observable<any>{
    let url: string= APIUrl.loyaltyPointHistory;
    let params: any = new HttpParams().set('userId', userId).set('days', days)
    return this.httpService.getParams(url,params)
  }

  consumerPromocodePointHistory(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.consumerPromoCodeHistory}/${id}`)
  }
  consumerLogsHistory(id:number): Observable<any> {
    return this.httpService.get(`${APIUrl.consumersLogsHistory}/${id}`)
  }
  getPaymentHistory(httpParams): Observable<any> {
    //let params = httpParams;
    //console.log(httppPa);
    return this.httpService.getParams(APIUrl.consumerPaymentHistory, httpParams);
  }
  getSelectedRetailer(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.getConsumer}/${id}`);
  }
  deleteComment(id: number): Observable<any> {
    return this.httpService.delete(`${APIUrl.deleteComments}/${id}`);
  }
  getComments(params): Observable<any> {
    return this.httpService.getParams(APIUrl.salesRepretailer, params);
  }
  addNewComment(params: Params): Observable<any> {
    return this.httpService.post(APIUrl.postComments, params);
  }
  getComment(id: number): Observable<any> {
    return this.httpService.get(`${APIUrl.consumerComments}/${id}`);
  }
  editComment(params: Params): Observable<any> {
    return this.httpService.put(APIUrl.editComments, params);
  }
    getallpaymentTypes() {
    let params = new HttpParams().set("config_name", "PlanType");
    return this.httpService.getRetailerData(APIUrl.paymentTypes, params);
  }
  // getallpaymentTypes() {
  //   return this.httpService.get(APIUrl.paymentTypes);
  // }

  manageConsumerPaymentReport(id, params) {
    return this.httpService.getParams(`${APIUrl.manageConsumerPaymentReport}`, params);
  }
}
